import type { QuoteItemInput } from './api';

/**
 * Vize teklifinde kişi sayısı (Ürün Sahibi, 09.10.2026): toplam kişi sayısıyla artmalı.
 *
 * Yetişkin ve çocuk ayrı ürün (ayrı fiyat), her satırın "Adet"i o türden kişi sayısıdır. Ekspres işlem
 * ise kişi başınadır (Arkan sözleşmesinde "Express surcharge" yetişkin ve çocuk için ayrı değil, kişi
 * başına tek ücret: `api/src/modules/finance/visa-prices.ts`). Ekspres satırı eskiden adet 1 ile
 * geliyordu ve kişi eklenince 1'de kalıyordu; toplam yalnız vize satırlarıyla artıyor, ekspres sabitti.
 *
 * Türkçe I tuzağı: `toLocaleLowerCase('tr-TR')` EXPRESS'i `express` yapmaz (I -> ı). Bu yüzden
 * ASCII katlama (`en-US`) kullanılıyor ve Türkçe karşılığı (`ekspres`) ayrıca aranıyor.
 */
export function isExpressLine(item: Pick<QuoteItemInput, 'itemType' | 'description'>): boolean {
  if (item.itemType !== 'VISA') return false;
  const key = item.description.toLocaleLowerCase('en-US');
  return /\b(express|ekspres)\b/.test(key);
}

const MAX_QUANTITY = 10_000;

/** Vize satırlarındaki kişi sayısı: ekspres olmayan VISA satırlarının adetleri toplamı. */
export function visaPersonCount(items: readonly Pick<QuoteItemInput, 'itemType' | 'description' | 'quantity'>[]): number {
  return items.reduce((sum, item) => (
    item.itemType === 'VISA' && !isExpressLine(item) && Number.isInteger(item.quantity) && item.quantity > 0 ? sum + item.quantity : sum
  ), 0);
}

/** Ekspres satırlarının adedini kişi sayısına eşitler. Kişi yoksa dokunmaz. Yeni dizi döner. */
export function syncExpressQuantities<T extends Pick<QuoteItemInput, 'itemType' | 'description' | 'quantity'>>(items: readonly T[]): T[] {
  const persons = Math.min(visaPersonCount(items), MAX_QUANTITY);
  if (persons < 1) return [...items];
  return items.map(item => (isExpressLine(item) && item.quantity !== persons ? { ...item, quantity: persons } : item));
}
